import React from 'react';
import {Card, CardContent, Typography, Grid} from '@material-ui/core';
import CountUp from 'react-countup';
import cx from 'classnames';

import styles from './Cards.module.css';
const  Cards = (data, country) =>{ 
    
    if(!data.data.Global){
        return "Loading...";
    }else if(data.country){
        var index;
        for(var key in data.data.Countries){
            if(data.data.Countries[key].Country === data.country){
                index = key;
            }
        }        
        return(   
            <div className={styles.container}>
                <Grid container spacing={3} justify="center">
                    <Grid item component={Card} xs={12} md={3} className={cx(styles.card, styles.confirmed)}>
                        <CardContent>
                            <Typography color="textSecondary" gutterBottom>Total Confirmed Cases</Typography>
                            <Typography variant="h5">
                                <CountUp start={0} end={data.data.Countries[index].TotalConfirmed} duration={2} separator=","/>
                            </Typography>
                            <Typography color="textSecondary">{new Date().toDateString()}</Typography>
                            <Typography varient="body2">Total Number of active cases of COVID-19</Typography>
                        </CardContent>
                    </Grid>
    
                    <Grid item component={Card} xs={12} md={3} className={cx(styles.card, styles.recovered)}>
                        <CardContent>
                            <Typography color="textSecondary" gutterBottom>Total Recovered Cases</Typography>
                            <Typography variant="h5">
                                <CountUp start={0} end={data.data.Countries[index].TotalRecovered} duration={2} separator=","/>
                            </Typography>
                            <Typography color="textSecondary">{new Date().toDateString()}</Typography>
                            <Typography varient="body2">Total Number of recovered cases of COVID-19</Typography>
                        </CardContent>
                    </Grid>
    
                    <Grid item component={Card}  xs={12} md={3} className={cx(styles.card, styles.deaths)}>
                        <CardContent>
                            <Typography color="textSecondary" gutterBottom>Total Deaths</Typography>
                            <Typography variant="h5">
                                <CountUp start={0} end={data.data.Countries[index].TotalDeaths} duration={2} separator=","/>
                            </Typography>
                            <Typography color="textSecondary">{new Date().toDateString()}</Typography>
                            <Typography varient="body2">Total Number of deaths caused by COVID-19</Typography>
                        </CardContent>
                    </Grid>
    
                    <Grid item component={Card} xs={12} md={3} className={cx(styles.card, styles.confirmed)}>
                        <CardContent>
                            <Typography color="textSecondary" gutterBottom>New Confirmed Cases</Typography>
                            <Typography variant="h5">
                                <CountUp start={0} end={data.data.Countries[index].NewConfirmed} duration={2} separator=","/>
                            </Typography>
                            <Typography color="textSecondary">{new Date(data.data.Countries[index].Date).toDateString()}</Typography>
                            <Typography varient="body2">Latest confirmed cases of COVID-19</Typography>
                        </CardContent>
                    </Grid>
    
                    <Grid item component={Card} xs={12} md={3} className={cx(styles.card, styles.recovered)}>
                        <CardContent>
                            <Typography color="textSecondary" gutterBottom>New Recovered Cases</Typography>
                            <Typography variant="h5">
                                <CountUp start={0} end={data.data.Countries[index].NewRecovered} duration={2} separator=","/>
                            </Typography>
                            <Typography color="textSecondary">{new Date(data.data.Countries[index].Date).toDateString()}</Typography>
                            <Typography varient="body2">Latest recovered cases of COVID-19</Typography>
                        </CardContent>
                    </Grid>
    
                    <Grid item component={Card}  xs={12} md={3} className={cx(styles.card, styles.deaths)}>
                        <CardContent>
                            <Typography color="textSecondary" gutterBottom>Deaths</Typography>
                            <Typography variant="h5">
                                <CountUp start={0} end={data.data.Countries[index].NewDeaths} duration={2} separator=","/>
                            </Typography>
                            <Typography color="textSecondary">{new Date(data.data.Countries[index].Date).toDateString()}</Typography>
                            <Typography varient="body2">Latest deaths caused by COVID-19</Typography>
                        </CardContent>
                    </Grid>
                </Grid>
            </div>
        )
    }
    return(
        <div className={styles.container}>
            <Grid container spacing={3} justify="center">
                <Grid item component={Card} xs={12} md={3} className={cx(styles.card, styles.confirmed)}>
                    <CardContent>
                        <Typography color="textSecondary" gutterBottom>Total Confirmed Cases</Typography>
                        <Typography variant="h5">
                            <CountUp start={0} end={data.data.Global.TotalConfirmed} duration={2} separator=","/>
                        </Typography>
                        <Typography color="textSecondary">{new Date().toDateString()}</Typography>
                        <Typography varient="body2">Total Number of active cases of COVID-19</Typography>
                    </CardContent>
                </Grid>

                <Grid item component={Card} xs={12} md={3} className={cx(styles.card, styles.recovered)}>
                    <CardContent>
                        <Typography color="textSecondary" gutterBottom>Total Recovered Cases</Typography>
                        <Typography variant="h5">
                            <CountUp start={0} end={data.data.Global.TotalRecovered} duration={2} separator=","/>
                        </Typography>
                        <Typography color="textSecondary">{new Date().toDateString()}</Typography>
                        <Typography varient="body2">Total Number of recovered cases of COVID-19</Typography>
                    </CardContent>
                </Grid>

                <Grid item component={Card}  xs={12} md={3} className={cx(styles.card, styles.deaths)}>
                    <CardContent>
                        <Typography color="textSecondary" gutterBottom>Total Deaths</Typography>
                        <Typography variant="h5">
                            <CountUp start={0} end={data.data.Global.TotalDeaths} duration={2} separator=","/>
                        </Typography>
                        <Typography color="textSecondary">{new Date().toDateString()}</Typography>
                        <Typography varient="body2">Total Number of deaths caused by COVID-19</Typography>
                    </CardContent>
                </Grid>

                <Grid item component={Card} xs={12} md={3} className={cx(styles.card, styles.confirmed)}>
                    <CardContent>
                        <Typography color="textSecondary" gutterBottom>New Confirmed Cases</Typography>
                        <Typography variant="h5">
                            <CountUp start={0} end={data.data.Global.NewConfirmed} duration={2} separator=","/>
                        </Typography>
                        <Typography color="textSecondary">{new Date().toDateString()}</Typography>
                        <Typography varient="body2">Latest confirmed cases of COVID-19</Typography>
                    </CardContent>
                </Grid>

                <Grid item component={Card} xs={12} md={3} className={cx(styles.card, styles.recovered)}>
                    <CardContent>
                        <Typography color="textSecondary" gutterBottom>New Recovered Cases</Typography>
                        <Typography variant="h5">
                            <CountUp start={0} end={data.data.Global.NewRecovered} duration={2} separator=","/>
                        </Typography>
                        <Typography color="textSecondary">{new Date().toDateString()}</Typography>
                        <Typography varient="body2">Latest recovered cases of COVID-19</Typography>
                    </CardContent>
                </Grid>

                <Grid item component={Card}  xs={12} md={3} className={cx(styles.card, styles.deaths)}>
                    <CardContent>
                        <Typography color="textSecondary" gutterBottom>Deaths</Typography>
                        <Typography variant="h5">
                            <CountUp start={0} end={data.data.Global.NewDeaths} duration={2} separator=","/>
                        </Typography>
                        <Typography color="textSecondary">{new Date().toDateString()}</Typography>
                        <Typography varient="body2">Latest deaths caused by COVID-19</Typography>
                    </CardContent>
                </Grid>
            </Grid>
        </div>
    )
}

export default Cards;